import { INeoAction } from './../Actions.interface';
import { REQUEST_ACTIONS, STATUS } from '../../Constants/Actions.constants';
import { IRole } from '../../Models/DTO/Role.model';

export default (state: IRole[] = [], action: INeoAction): IRole[] => {
  const { type, status, payload } = action;

  if (status === STATUS.SUCCESS) {
    if (type === REQUEST_ACTIONS.PROVIDER_ROLES) {
      return payload;
    }

    if (type === REQUEST_ACTIONS.CLAIM_MANAGER_RIGHTS) {
      return state;
    }
  }
  return state;
};
